import React from "react";

const ShimmerUI = () => {
  return (
    <div className="rounded-lg shadow-sm bg-[#f9f9f9] ">
      <div className="flex items-center justify-center p-5 m-3 rounded-3xl bg-white w-60 h-48"></div>

      <div className="flex flex-col items-start justify-start mx-2  flex-wrap ">
        <h3 className="text-decor font-bold mx-1 w-40 h-6 bg-gray-300 my-2 rounded-2xl"></h3>
        <p className="text-decor  text-gray-700 mx-1 w-40 h-4 bg-gray-300 my-2 rounded-2xl"></p>
        <p className="text-decor text-gray-700 mx-1 w-24 h-4 my-2 bg-gray-300 rounded-2xl"></p>
        <p className="text-decor text-gray-700 mx-1 mb-2 w-16 h-4 my-2 bg-gray-300 rounded-2xl"></p>
      </div>
    </div>
  );
};

export default ShimmerUI;
